/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picto-profil-fumeur-11': {
    width: 46,
    height: 27,
    viewBox: '0 0 46 27',
    data: '<path pid="0" class="st0" d="M37.7 24.4h-3.2v-5h3.2v5zm-5.8 0H11.4v-5h20.5v5zm-23 0H2.5v-5h6.4v5zm30-7.5H1.3c-.7 0-1.3.6-1.3 1.3v7.5c0 .7.6 1.3 1.3 1.3H39c.7 0 1.3-.6 1.3-1.3v-7.5c-.1-.8-.7-1.3-1.4-1.3M43.9 6.5c-.9-.9-1.4-1.8-1.3-2.7.1-1.4 1.2-2.3 1.3-2.4.3-.3.4-.7.1-1.1-.3-.3-.7-.4-1.1-.1-.1.1-1.7 1.4-1.8 3.4-.1 1.4.5 2.7 1.7 3.9.9.9 1.3 1.8 1.3 2.8 0 1.5-1.3 2.7-1.3 2.7-.3.3-.3.8-.1 1.1.4.4.9.2 1.1.1.1-.1 1.7-1.6 1.8-3.8.1-1.4-.5-2.7-1.7-3.9"/><path pid="1" class="st0" d="M40.7 10.3c0 1.5-1.3 2.7-1.3 2.7-.3.3-.3.8-.1 1.1.4.4.9.2 1.1.1.1-.1 1.7-1.6 1.8-3.8 0-1.4-.6-2.7-1.8-3.9-.9-.9-1.4-1.8-1.3-2.7.1-1.4 1.2-2.3 1.3-2.4.3-.3.4-.7.1-1.1-.3-.3-.7-.4-1.1-.1-.1.1-1.7 1.4-1.8 3.4-.1 1.4.5 2.7 1.8 3.9.9.9 1.3 1.9 1.3 2.8"/>'
  }
})
